import { render, staticRenderFns } from "./IPViewEmail.vue?vue&type=template&id=c0900572&scoped=true&lang=pug&"
import script from "./IPViewEmail.vue?vue&type=script&lang=js&"
export * from "./IPViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./IPViewEmail.vue?vue&type=style&index=0&id=c0900572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0900572",
  null
  
)

export default component.exports